var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cubes',{staticClass:"mx-2 my-1"}),_c('unload'),_c('catalogs',{staticClass:"mx-2 my-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }